// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconPlus: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="currentColor">
            <path
                fillRule="evenodd"
                d="M401,1049 L401,1052.714 L405,1052.71429 L405,1054.57143 L401,1054.571 L401,1058.28571 L399,1058.28571 L399,1054.571 L395,1054.57143 L395,1052.71429 L399,1052.714 L399,1049 L401,1049 Z"
                transform="translate(-395 -1049)"
            />
        </svg>
    );
};

export default React.memo(IconPlus);
